import { useCheckoutContext } from "context/checkout-context";
import { toMoneyWithMaximumTwoDecimalDigits } from "utils/currency";
import { CheckoutSummaryGcxCash } from "..";
import "./index.scss";
import PlatformFee from "../platform-fee";

export const CheckoutSummaryOrder = ({ closeCouponArea }) => {
  const {
    checkoutData: {
      promo,
      total,
      subtotal,
      total_savings,
      service_fee,
      ...checkoutData
    }
  } = useCheckoutContext();

  const shouldDisplayGcxCash =
    checkoutData.points?.amount && checkoutData.points?.label;

  return (
    <div
      className="checkout-summary-order"
      data-testid="checkout-summary-order"
    >
      <div className="checkout-row checkout-subtotal">
        <p className="checkout-label">Subtotal:</p>
        <p className="checkout-value">
          {toMoneyWithMaximumTwoDecimalDigits(subtotal)}
        </p>
      </div>
      {service_fee?.applied && service_fee?.amount > 0 && (
        <PlatformFee serviceFee={service_fee} noPadding />
      )}
      {promo?.applied && (
        <div className="checkout-row checkout-promo">
          <p className="checkout-label">Promo:</p>
          <p className="checkout-value">
            {toMoneyWithMaximumTwoDecimalDigits(promo?.amount)}
          </p>
        </div>
      )}
      {!!shouldDisplayGcxCash && (
        <CheckoutSummaryGcxCash closeCouponArea={closeCouponArea} />
      )}
      <div className="checkout-row checkout-total">
        <p className="checkout-label">Total:</p>
        <p className="checkout-value">
          {toMoneyWithMaximumTwoDecimalDigits(total)}
        </p>
      </div>
      <div className="checkout-row checkout-savings">
        <p className="checkout-label">Your savings:</p>
        <p className="checkout-value">
          {toMoneyWithMaximumTwoDecimalDigits(total_savings)}
        </p>
      </div>
    </div>
  );
};
